// extracted by mini-css-extract-plugin
export default {"button":"BlueButton_button__CFWhh"};